import React from 'react';
import ReactModal from 'react-modal';
import { Button } from './Button';

const modalStyles = {
	content: {
		top: '40%',
		left: '48%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		width: '300px',
		height: 'auto',
		minHeight: '0px'
	}
};

interface GenericModalProps {
	isOpen: boolean;
	onRequestClose: () => void;
	children: React.ReactNode;
	modalStyle: any;
}

export const GenericModal: React.FC<GenericModalProps> = (props: GenericModalProps) => (
	<ReactModal
		isOpen={props.isOpen}
		onRequestClose={props.onRequestClose}
		className="reveal large"
		overlayClassName="reveal-overlay"
		contentLabel="Modal"
		style={props.modalStyle}
		appElement={document.getElementById('root') as HTMLElement}
	>
		{props.children}
	</ReactModal>
);

interface TextModalProps {
	isOpen: boolean;
	onRequestClose: () => void;
	doConfirm?: () => void;
	content: string;
}

export const TextModal: React.FC<TextModalProps> = (props: TextModalProps) => (
	<GenericModal isOpen={props.isOpen} onRequestClose={props.onRequestClose} modalStyle={modalStyles}>
		<p>{props.content}</p>
		{props.doConfirm && (
			<Button
				className="mini"
				onClick={() => {
					props.doConfirm!();
					props.onRequestClose();
				}}
			>
				Vahvista
			</Button>
		)}
		<Button className="mini invisible" onClick={props.onRequestClose}>
			{props.doConfirm ? 'Peruuta' : 'Sulje'}
		</Button>
	</GenericModal>
);
